module.exports = __webpack_public_path__ + "img/center-guide-hero.60fd1661.png";